import { Toaster } from 'sonner';

export const MessageToaster = () => (
  <Toaster
    id="message-toaster"
    position="top-center"
    offset={48}
    swipeDirections={['top', 'left', 'right', 'bottom']}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pointerEvents: 'auto',
    }}
  />
);
